import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateCollateral(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerCreateCollateralAttempt', handleCreateCollateral, api);
}

function* handleCreateCollateral(api: CustomerGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { marketValue, productName, ...restOfCollateralParams } = reduxState.customer.createCollateralParams;

    const response = yield* call([api, api.createCollateral], {
        authToken,
        ...restOfCollateralParams,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerCreateCollateralFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerCreateCollateralSuccess());
        yield put(combinedActions.customerSetCustomerListingIndex({ index: 0 }));
        yield put(combinedActions.customerGetCustomerListingAttempt());

        // reset redux value
        yield put(combinedActions.customerResetCreateCollateralState());
        yield put(combinedActions.customerResetCustomerDetails());
        yield put(combinedActions.customerClearCreateCollateralParams());
        yield put(combinedActions.customerSetCreateCollateralModalIsOpen(false));
        yield put(combinedActions.customerSetIsCreateCollateralFormFilled(false));

        toast.success(SuccessMessages.CustomerCreateCollateralSuccess);
    }
}
